<template>
  <div class="pvd-checkbox m-medium-top">
    <input
      :id="`input${idPrefix}`"
      :key="name"
      v-model="mutableCheckBoxValue"
      :name="name"
      :type="type"
      :aria-describedby="errors.has(name) ? `${idPrefix}Error` : null"
      @change="handleClick"
    >
    <label
      :for="`input${idPrefix}`"
      :class="labelClass"
    >
      <span
        class="checkmark"
        aria-hidden="true"
      >
        <pvd-icon icon="checkmark" />
      </span>
      {{ label }}
    </label>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';

export default {
  name: 'InputConfirm',
  mixins: [
    dataHelper,
    measurement,
  ],
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    taxHolding: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    idPrefix: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    trackEvents: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mutableCheckBoxValue: {
      get() {
        return this.taxHolding;
      },
      set(newValue) {
        this.$emit('update:taxHolding', newValue);
      },
    },
  },
  methods: {
    handleClick(event) {
      if (event && this.trackEvents) {
        const name = `${this.idPrefix}-confirm-${event.target.checked}`;
        this.track(name, 'interaction');
      }
    },
  },
};
</script>

<style scoped>
</style>
